import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/features')({
  component: FeaturesLayout,
})

function FeaturesLayout() {
  return <Outlet />
}
